import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { Banner, BannerText, BannerLogo } from "../../styles/Banner";
import { Typography, Grid, Box } from '@mui/material';
import { funcionalidades, servicos } from '../../constants/Institucional/icons';
import {  AboutSection, Container, Imagem } from './styled';
import {useTheme, useMediaQuery} from '@mui/material';
import InfoCard from './Card';
const Institucional = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <>
            {/* Banner */}
            <Banner>
                <BannerText>
                    <p>
                        <a href="https://www.meucupom.com/" target='_blank' rel="noreferrer">Home</a> &gt; Institucional &gt; Quem somos
                    </p>
                    <Box>
                        <Typography variant='h2' sx={{
                        fontSize: { xs: '1.2rem', sm: '2rem', md: '2rem', fontWeight: 'bold', textAlign: 'center' }
                    }}>Quem somos?</Typography>
                    </Box>
                
                    <Box>
                        <Link sx={{
                            color: 'white', 
                            marginRight: '10px', 
                            fontSize: { xs: '0.8rem', sm: '1rem', md: '1rem',
                        }}} component={RouterLink} to="/institucional/quem-somos" underline="hover">Quem somos?</Link>
                        <Link 
                        sx={{
                            color: 'white', 
                            marginRight: '10px', 
                            fontSize: { xs: '0.8rem', sm: '1rem', md: '1rem',
                        }}}
                        component={RouterLink} to="/institucional/imprensa" underline="hover">Imprensa?</Link>
                        <Link
                        sx={{
                            color: 'white',  
                            fontSize: { xs: '0.8rem', sm: '1rem', md: '1rem',
                        }}}
                        component={RouterLink} to="/institucional/contato" underline="hover">Contato?</Link>
                    </Box>
                </BannerText>
                <BannerLogo>
                    <img 
                        src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png" 
                        alt="MeuCupom Logo" 
                    />
                </BannerLogo>
            </Banner>
            {/* Quem somos */}
            <Container>
                <AboutSection>
                    <Typography variant='body1' paragraph>
                        Fundado em 2014, o MeuCupom.com é o primeiro site de cupons do Brasil que garante ao usuário descontos reais em tempo real, e disponibiliza uma grande variedade de cupons e ofertas de parceiros varejistas nacionais e internacionais. O MeuCupom.com tem uma proposta clara: não deixar seus clientes perderem uma oportunidade de desconto sequer, permitindo uma compra online fácil e confiável.
                    </Typography>
                </AboutSection>
                <AboutSection>
                        <Typography variant='body1' paragraph>
                            A plataforma combina tecnologia e a experiência do consumidor de maneira efetiva, com conteúdo dinâmico e constantemente ajustável às preferências do usuário, baseado em um algoritmo proprietário.
                        </Typography>
                        <Typography variant='body1' paragraph>
                            O MeuCupom.com é uma empresa da pw brands, holding de negócios digitais que investe, constantemente, em tecnologia de ponta para suas marcas.
                        </Typography>
                </AboutSection>
            </Container>
            <Typography  gutterBottom  sx={{ textAlign: 'center',  marginTop: '3rem', fontWeight: 'bold',
                fontSize: { xs: '1.2rem', sm: '2rem', md: '2rem', color: 'var(--c-brand-accent-bright)' }
            }}>
                COMO USAR O MEUCUPOM.COM
            </Typography>
            <Box display="flex" justifyContent="center" my={4}>
                <iframe width={isMobile ? '90%' : '760'} height={isMobile ? '300' : '415'}
                    src="https://www.youtube.com/embed/YuXK2Q4Avf8?si=mPu62EC2A3iQAeCj"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </Box>
            <Box sx={{ padding: '60px 20px', backgroundColor: '#f5f5f5'}}>
                <Typography variant="h4" gutterBottom textAlign="center">
                    Funcionalidades
                </Typography>
                <Grid container spacing={1} justifyContent="center" sx={{ marginTop: 2, gap: 6 }}>
                    {funcionalidades.map((item, index) => (
                        <Grid item xs={5} sm={4} md={2} key={index}>
                            <InfoCard {...item} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'center' : 'flex-start', justifyContent: 'center', gap: 8, maxWidth: '1400px', margin: '40px auto', }}>
                <Box sx={{ width: isMobile ? '100%' : '50%',  display: 'flex', justifyContent: 'center' }}>
                    <Imagem src="https://cdn.meucupom.com/institucional/quem-somos/site.png" alt="" />
                </Box>
                <Box sx={{ width: isMobile ? '94%' : '50%', textAlign: 'justify' }}>
                    <Typography gutterBottom sx={{ fontSize: { xs: '1.2rem', sm: '2rem', md: '2rem', color: 'var(--c-brand-accent-bright)', fontWeight: 'bold' }
                    }}>Aproveitando a vida por menos</Typography>
                    <Typography variant='body1' paragraph sx={{marginBottom: 2}}>
                        Oferecemos as melhores ofertas, produtos e cupons de descontos exclusivos da internet. Influenciando na tomada de decisão de compra do seus clientes. As soluções do MeuCupom são comprovados para aumentar as vendas online, aumentar o share do mercado, aumentar o valor médio das compras e conquistar novos clientes.
                    </Typography>
                    <Typography variant='body1' paragraph>
                        Nós oferecemos uma variedade de oportunidades para promover sua marca e seus descontos. Direcionamos os usuários para o seu site, através desses canais do MeuCupom, onde os usurários podem buscar, descobrir e interagir com a sua marca.
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ padding: '60px 20px', backgroundColor: '#f5f5f5' }}>
                <Typography variant="h4" gutterBottom textAlign="center">
                    Serviços
                </Typography>
                <Grid container spacing={1} justifyContent="center" sx={{ marginTop: 2, gap: 6 }}>
                    {servicos.map((item, index) => (
                        <Grid item xs={5} sm={4} md={2} key={index}>
                        <InfoCard {...item} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    )
}
export default Institucional;